<template>
  <div class="bottom text-theme-gray font-size-12">
    <div class="top q-mb-sm">
      <span class="q-mr-sm">Powered by</span>
      <a href="javascript: void(0);">
        <img class="icon" :src="icons" alt="Bakmi GM logo" />
      </a>
    </div>
    <div v-if="isPreRegister">
      <span>{{ $t('home.preRegisTip') }}</span>
      <a class="text-primary link" href="javascript: void(0);">
        {{ $t('home.learnMore') }}
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    icons: {
      type: String,
      // default: 'https://static.bakmigm.co.id/menu/55296cbb379b4b5255fd3e663c583042.svg',
      default: 'https://static.bakmigm.co.id/menu-buyer/order/Bakmi-GM-Logo.svg',
    },
    status: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      // logoJump: 'https://business.horego.com/?utm_source=desty-menu&utm_medium=pre-register&utm_campaign=footer-pr&utm_content=xxx',
    };
  },
  computed: {
    isPreRegister() {
      return this.storeInfo.status.statusCode === 400;
    },
  },
};
</script>

<style lang="scss" scoped>
.bottom {
  text-align: center;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: $grayBg;
  padding: 15px 0;
  z-index: 100;
  .icon {
    display: inline-block;
    width: 64px;
    vertical-align: middle;
  }
  .top {
    span {
      vertical-align: middle;
    }
  }
  .link {
    margin-left: 4px;
    text-decoration: underline;
  }
}
</style>
